export enum AppsSourceType {
    GoogleStore = "googleStore",
    AppleStore = "appleStore",
}
